/**
 * Privilege stored on the logged-in pharmacy user.
 * Super admin (`isAdmin === true`) has no assigned privilege; callers treat that as full access.
 */

export function readPharmacyPrivilege(user) {
	if (!user || user.isAdmin === true) return null;
	const privilege = user.assignedPrivilege;
	if (!privilege || typeof privilege !== "object" || Array.isArray(privilege)) {
		return null;
	}
	return privilege;
}

function hasOwn(object, key) {
	return object != null && Object.prototype.hasOwnProperty.call(object, key);
}

/**
 * Keep isAdmin and assignedPrivilege when a later profile payload omits them.
 * An explicit null or false on `next` is kept.
 */
export function withStoredPharmacyPrivilege(nextPharmacy, previousPharmacy) {
	const next =
		nextPharmacy && typeof nextPharmacy === "object" ? { ...nextPharmacy } : {};
	const previous =
		previousPharmacy && typeof previousPharmacy === "object"
			? previousPharmacy
			: null;

	if (!hasOwn(next, "isAdmin") && previous) {
		next.isAdmin = previous.isAdmin === true;
	}
	if (!hasOwn(next, "assignedPrivilege") && previous) {
		next.assignedPrivilege = previous.assignedPrivilege ?? null;
	}
	return next;
}
